import {
  ChangeDetectionStrategy,
  Component,
  DOCUMENT,
  inject,
  Renderer2,
} from '@angular/core';

import { ENV_TOKEN, TEXT_DIRECTION_TOKEN } from './app.tokens';
import { Env } from './core/interfaces/env.interface';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AppComponent {
  private readonly document = inject<Document>(DOCUMENT);
  private readonly textDirection = inject(TEXT_DIRECTION_TOKEN);
  private readonly env = inject<Env>(ENV_TOKEN);
  private readonly renderer = inject(Renderer2);

  private readonly pageTitle = $localize`:Текст на вкладке браузера@@track-map/app/page-title:Информация о поездке`;

  constructor() {
    this.document.title = `${this.pageTitle} - ${this.env.appName}`;
    this.renderer.setAttribute(this.document.body, 'dir', this.textDirection);
  }
}
